import {
  createContext,
  useContext,
  useState,
  useMemo,
  type ReactNode,
} from 'react';

type ItineraryVisibilityContextType = {
  isItineraryVisible: boolean;
  isItineraryLoading: boolean;
  setItineraryVisible: (visible: boolean) => void;
  setItineraryLoading: (visible: boolean) => void;
};

const ItineraryVisibilityContext =
  createContext<ItineraryVisibilityContextType>({
    isItineraryVisible: false,
    isItineraryLoading: false,
    setItineraryVisible: () => {},
    setItineraryLoading: () => {},
  });

export const ItineraryVisibilityProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [isItineraryVisible, setItineraryVisible] = useState(false);
  const [isItineraryLoading, setItineraryLoading] = useState(false);

  const value = useMemo(
    () => ({
      isItineraryVisible,
      isItineraryLoading,
      setItineraryVisible,
      setItineraryLoading,
    }),
    [isItineraryVisible, isItineraryLoading],
  );

  return (
    <ItineraryVisibilityContext.Provider value={value}>
      {children}
    </ItineraryVisibilityContext.Provider>
  );
};

export const useItineraryVisibility = () =>
  useContext(ItineraryVisibilityContext);
